<div class="p-3">
  <div class="row justify-content-between mb-2">
    <h5 class="text-primary">{{ "DATA_STUDIO.DATA_ANALYSIS.Y_AXIS_CONFIG" |translate }}</h5>
    <i (click)="cancel()" class="cursor-pointer close-button far fa-times ml-2"></i>
  </div>
  <hr>
    <table>
      <thead>
        <th class="custom-axis-column">{{ "DATA_STUDIO.DATA_ANALYSIS.AXIS_NAME" |translate }}</th>
        <th class="custom-axis-column">{{ "DATA_STUDIO.DATA_ANALYSIS.MIN_VALUE" |translate }}</th>
        <th class="custom-axis-column">{{ "DATA_STUDIO.DATA_ANALYSIS.MAX_VALUE" |translate }}</th>
        <th class="custom-axis-column"></th>
      </thead>
      <tbody>
        @for (axis of yAxisData; track $index) {
          <tr class="custom-axis-row">
            <td>
              <label class="custom-axis-input custom-axis-input-title mb-0">{{ axis.title }}</label>
            </td>
            <td>
              <input class="custom-axis-input" [disabled]="!axis.locked" [(ngModel)]="axis.min">
            </td>
            <td>
              <input class="custom-axis-input" [disabled]="!axis.locked" [(ngModel)]="axis.max">
            </td>
            <td>
              <div class="custom-axis-toggle-container">
                <lib-switch [theme$]="theme$" [model]="axis.locked" (toggleStateChanged)="unlockAxis(axis)"></lib-switch>
                <span class="font-size-small ml-2">{{ "DATA_STUDIO.DATA_ANALYSIS.CUSTOM" |translate }}</span>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <hr>
      <div class="row justify-content-between align-items-center">
        <div>
          <p class="custom-axis-popup-reset" (click)="reset()">{{ "DATA_STUDIO.DATA_ANALYSIS.RESET_TO_DEFAULT" |translate }}</p>
        </div>
        <div>
          <lib-button
            id="custom-axis-popup-cancel"
            [label]="'BUTTONS.CANCEL' |translate"
            class="mr-2 modify-button"
            [fontSize]="18"
            [align]="'center'"
            [color]="'secondary'"
            (click)="cancel()">
          </lib-button>
          <lib-button
            id="custom-axis-popup-confirm"
            [label]="'BUTTONS.CONFIRM' |translate"
            class="mr-2 modify-button"
            [fontSize]="18"
            [align]="'center'"
            (click)="confirm()">
          </lib-button>
        </div>
      </div>
    </div>